import { Type } from '@angular/core';

export class TopBarItem {
  constructor(public component: Type<any>, public data: any) {}
}
